<template>
    <el-dialog
      :visible.sync="isOpen"
      width="900px"
      :show-close="true"
      class="egl-dialog-elm channel-dialog"
      :title="$locale('global.item') + actionText"
      :close-on-click-modal="false"
    >
      <el-form :disabled="this.action == 'detail'" :model="form" ref="detailForm" :rules="formRules" label-position="top">
        <div class="form-module">
          <div class="form-module-tit">{{ $locale("global.basicInfo") }}</div>
          <el-row>
            <el-col :span="12">
              <el-form-item :label="$locale('shop.barcode')" class="long-item" prop="barCode">
                <el-input
                  v-model="form.barCode"
                  :placeholder="$locale('shop.plsEnterBarcode')"
                  maxlength="255"
                ></el-input>
              </el-form-item>
              <el-form-item :label="$locale('shop.productCode')" class="long-item" prop="productCode">
                <el-input
                  v-model="form.productCode"
                  :placeholder="$locale('shop.productCode.p')"
                  maxlength="255"
                ></el-input>
              </el-form-item>
              <el-form-item :label="$locale('global.name')" class="long-item" prop="name">
                <el-input
                  v-model="form.name"
                  :placeholder="$locale('form.plsEnterYourName')"
                  maxlength="255"
                ></el-input>
              </el-form-item>
              <el-form-item :label="$locale('global.price_taxIncluded')" class="long-item" prop="price">
                <el-input
                  v-model.number="form.price"
                  :placeholder="$locale('form.plsEnterPrice')"
                  @input.native="getNotTaxPrice"
                  @blur="getNotTaxPrice"
                  maxlength="20"
                >
                  <template slot="prepend">¥</template>
                </el-input>
              </el-form-item>
              <el-form-item :label="$locale('shop.taxDisplay')" prop="taxRate">
                <TaxSelect v-model="form.taxRate" :isSaleOption="false" @change="getNotTaxPrice"/>
                <!-- <el-select v-model="form.taxRate" @change="getNotTaxPrice">
                  <el-option
                    v-for="item in taxIndication"
                    :label="taxRatesMap[item]"
                    :value="item"
                    :key="item"
                  ></el-option>
                </el-select> -->
              </el-form-item>
              <el-form-item :label="$locale('shop.amount_excludingTax')" class="not-tax-price" prop="notTaxPrice">
                <el-input v-model="form.notTaxPrice" disabled maxlength="20">
                  <template slot="prepend">¥</template>
                </el-input>
              </el-form-item>
              <el-form-item :label="$locale('shop.purchasePrice_taxIncluded')"  prop="productCost">
                <el-input v-model="form.productCost" maxlength="20" @input.native="getNotTaxPrice" @change="value => priceFormatter(value, 'productCost')">
                  <template slot="prepend">¥</template>
                </el-input>
              </el-form-item>
              <el-form-item :label="$locale('shop.purchasePriceUnit_taxIncluded')" class="not-tax-price" prop="priceWithoutTax">
                <el-input v-model="form.priceWithoutTax" maxlength="20" @input.native="getTaxedPrice" @change="value => priceFormatter(value, 'priceWithoutTax')">
                  <template slot="prepend">¥</template>
                </el-input>
              </el-form-item>
              <el-form-item
                :label="$locale('shop.consumptionTax_purchaseCost')"
                class="long-item"
                prop="taxRateCost"
              >
                <TaxSelect v-model="form.taxRateCost" :isSaleOption='true' @change="getNotTaxPrice"/>
                <!-- <el-select v-model="form.taxRateCost" @change="getNotTaxPrice">
                  <el-option
                    v-for="item in saleTaxOption"
                    :label="item.label"
                    :value="item.value"
                    :key="item.value"
                  ></el-option>
                </el-select> -->
              </el-form-item>
            </el-col>
            <el-col :span="10" :offset="2">
              <el-form-item style="width: 100%;" :label="$locale('global.image') + $locale('shop.upload.tips')" class="upload">
                <UploadContainer
                  :type="'B'"
                  :imageList="[form.imageUrl]"
                  @onSuccess="({response}) => uploadSuccess(response)"
                  @onDelete="deleteImg"
                ></UploadContainer>
              </el-form-item>
            </el-col>
          </el-row>
        </div>

        <div class="form-module">
          <div class="form-module-tit">{{ $locale("shop.inventorySetting") }}</div>
          <el-row :gutter="20" class="inventory-setting">
            <el-col :span="8">
              <el-form-item :label="$locale('shop.inventoryControl')" prop="useStock">
                <BoolSelect v-model="form.useStock" :optionObj="boolSelectObj"></BoolSelect>
              </el-form-item>
            </el-col>

            <el-col :span="8">
              <el-form-item :label="$locale('shop.autoSoldOut')" prop="useAutoSoldOut">
                <BoolSelect
                  v-model="form.useAutoSoldOut"
                  :optionObj="boolSelectObj"
                  :disabled="!form.useStock"
                ></BoolSelect>
              </el-form-item>
            </el-col>

            <el-col :span="8">
              <el-form-item :label="$locale('shop.stockLocation')" prop="stockPlace">
                <el-input
                  v-model="form.stockPlace"
                  :placeholder="$locale('shop.plsEnterStockLocation')"
                  :disabled="isDisStockPlace"
                  maxlength="255"
                ></el-input>
              </el-form-item>
            </el-col>

            <el-col :span="8">
              <el-form-item :label="$locale('global.unit')" prop="unit">
                <el-input
                  v-model="form.unit"
                  :placeholder="$locale('form.plsEnterUnit')"
                  maxlength="255"
                ></el-input>
              </el-form-item>
            </el-col>
          </el-row>
        </div>

        <div class="form-module">
          <div class="form-module-tit">{{ $locale("shop.salesRelatedInfo") }}</div>
          <div class="clearfix">
            <el-form-item :label="$locale('shop.productType')" prop="productType">
              <el-select v-model="form.productType" disabled>
                <el-option
                  v-for="item in productTypeOption"
                  :label="saleFormMap[item]"
                  :value="item"
                  :key="item"
                ></el-option>
              </el-select>
            </el-form-item>
            <el-form-item :label="$locale('shop.concessionAdd.detail.ticketSalesSetting.salesDepartment')" prop="salesDepartment">
                <el-select v-model="form.salesDepartment"></el-select>
              </el-form-item>
            <el-form-item :label="$locale('shop.supplier')" prop="supplier">
              <!-- <el-select v-model="form.clientId" filterable clearable>
                <el-option
                  v-for="item in clientList"
                  :label="item.name"
                  :value="item.id"
                  :key="item.id"
                ></el-option>
              </el-select> -->
              <!-- <template v-if="isOpen">
                <remote-select
                  type="client"
                  :isMultiple="false"
                  v-model="form.clientId"
                  :formValue.sync="form.clientId"
                  :actionType="action"
                ></remote-select>
              </template> -->
              <RemoteSelectV2
                ref="selectV2Client"
                type="client"
                :list="comClientList"
                v-model="form.clientId"
                :isMultiple="false"
                :formValue.sync="form.clientId"
                :fields="['id', 'name']"
                @setList="arr => comClientList = arr"
              />
            </el-form-item>
          </div>
        </div>

        <div class="form-module">
          <div class="form-module-tit">{{ $locale("shop.couponSetting") }}</div>
          <div class="clearfix">
            <el-form-item :label="$locale('shop.unavailableCoupon')" prop="unavailableCoupons">
              <!-- <el-select v-model="form.unavailableCoupons"
                         :multiple="true"
                         clearable>
                <el-option
                        v-for="item in couponTypeList"
                        :label="item.name"
                        :value="item.id"
                        :key="item.id"
                ></el-option>
              </el-select> -->
              <!-- <template v-if="isOpen">
                <remote-select
                  v-model="form.unavailableCoupons"
                  :formValue.sync="form.unavailableCoupons"
                  :actionType="action"
                  @selectAll="arr => form.unavailableCoupons = arr"
                ></remote-select>
              </template> -->
              <RemoteSelectV2
                ref="selectV2Coupon"
                type="coupon"
                :list="comCouponList"
                v-model="form.unavailableCoupons"
                :formValue.sync="form.unavailableCoupons"
                :fields="['id', 'name']"
                @setList="arr => comCouponList = arr"
                @selectAll="arr => form.unavailableCoupons = arr"
                :isSelectAllFunc="true"
                :isCollapse="true"
              />
            </el-form-item>
          </div>
        </div>

        <div class="form-module">
          <div class="form-module-tit">{{ $locale("shop.optionSetting") }}</div>
          <el-form-item label="オプションタイトル" prop="optionTitle">
            <el-input v-model="form.optionTitle" />
          </el-form-item>
          <div class="clearfix dynamic-table">
            <div class="table-box">
              <el-table :data="form.options" class="egl-table" border>
                <el-table-column :label="$locale('global.productCode')" align="center">
                  <template slot-scope="scope">
                    <el-input
                      v-model="scope.row.productCode"
                      :placeholder="$locale('form.plsEnterProductCode')"
                      maxlength="255"
                    ></el-input>
                  </template>
                </el-table-column>
                <el-table-column :label="$locale('global.name')" align="center">
                  <template slot-scope="scope">
                    <el-input
                      v-model="scope.row.name"
                      :placeholder="$locale('form.plsEnterYourName')"
                      maxlength="255"
                    ></el-input>
                  </template>
                </el-table-column>
                <el-table-column :label="$locale('shop.stockLocation')" align="center">
                  <template slot-scope="scope">
                    <el-input
                      v-model="scope.row.stockPlace"
                      :placeholder="$locale('shop.plsEnterStockLocation')"
                      maxlength="255"
                    ></el-input>
                  </template>
                </el-table-column>
                <el-table-column :label="$locale('shop.barcode')" align="center">
                  <template slot-scope="scope">
                    <el-input
                      v-model="scope.row.barCode"
                      :placeholder="$locale('shop.plsEnterBarcode')"
                      maxlength="255"
                    ></el-input>
                  </template>
                </el-table-column>
              </el-table>
            </div>
            <div class="table-handle-btn" v-if="this.action != 'detail'">
              <div class="btn-item" v-for="(obj, i) in form.options" :key="i">
                <i
                  class="el-icon-remove-outline"
                  v-if="form.options.length > 1"
                  @click="removeTableRow(i)"
                ></i>
                <i
                  class="el-icon-circle-plus-outline"
                  v-if="i == form.options.length - 1"
                  @click="addTableRow"
                ></i>
              </div>
            </div>
          </div>
        </div>

        <div class="form-module channel-inventory" v-if="(form.options.length === 1 && form.options[0].name != '') || form.options.length > 1">
          <div class="form-module-tit">{{ $locale("shop.materialSetting") }}</div>
          <el-form-item :label="$locale('shop.optionalMaterial')" prop="options">
            <div class="inventory-list" v-for="(optionItem, i) in form.options" :key="i">
              <div class="inventory-name">{{optionItem.name}}</div>
              <template v-for="(ingredient, j) in optionItem.ingredientIds">
                <el-row :gutter="20" :key="optionItem.name + j" v-if="optionItem.name != ''">
                  <el-col :span="8">
                    <el-select
                      v-model="form.options[i].ingredientIds[j].ingredientId"
                      :placeholder="$locale('shop.plsSelectMaterial')"
                      @change="val => chooseIngredient(i, j, val)"
                    >
                      <el-option
                        v-for="item in ingredientList"
                        :label="item.name"
                        :value="item.id"
                        :key="item.id"
                      ></el-option>
                    </el-select>
                  </el-col>
                  <el-col :span="6">
                    <el-input
                      v-model="form.options[i].ingredientIds[j].ingredientQty"
                      :placeholder="$locale('form.plsEnterNum')"
                      @change="value => priceFormatterForIngredient(value, i, j, true)"
                      maxlength="10"
                    ></el-input>
                  </el-col>
                  <el-col :span="3" class="unit" v-if="form.options[i].ingredientIds[j].ingredientId">
                    <template v-for="item in ingredientList">
                      <span :key="item.id" v-if="item.id == form.options[i].ingredientIds[j].ingredientId">{{ item.unit }}</span>
                    </template>
                  </el-col>
                  <el-col
                    :span="5"
                    class="handle-btn"
                    v-if="action != 'detail'"
                  >
                    <i
                      class="el-icon-remove-outline"
                      v-if="form.options[i].ingredientIds.length > 1"
                      @click="removeIngredient(i, j)"
                    ></i>
                    <i
                      class="el-icon-circle-plus-outline"
                      v-if="j == form.options[i].ingredientIds.length - 1"
                      @click="addIngredient(i)"
                    ></i>
                  </el-col>
                </el-row>
              </template>
            </div>
          </el-form-item>
        </div>

        <div class="form-module channel-inventory" v-else>
          <div class="form-module-tit">{{ $locale("shop.materialSetting") }}</div>
          <el-form-item :label="$locale('shop.optionalMaterial')" prop="ingredientIds">
            <div class="inventory-list">
              <div class="inventory-name">{{form.name}}</div>
              <template v-for="(ingredient, j) in form.ingredientIds">
                <el-row :gutter="20" :key="j">
                  <el-col :span="8">
                    <el-select
                      v-model="form.ingredientIds[j].ingredientId"
                      :placeholder="$locale('shop.plsSelectMaterial')"
                      @change="val => chooseIngredientIds(j, val)"
                      :filterable="true"
                    >
                      <el-option
                        v-for="item in ingredientList"
                        :label="item.name"
                        :value="item.id"
                        :key="item.id"
                      ></el-option>
                    </el-select>
                  </el-col>
                  <el-col :span="6">
                    <el-input
                      @change="value => priceFormatterForIngredient(value, null, j, false)"
                      v-model="form.ingredientIds[j].ingredientQty"
                      :placeholder="$locale('form.plsEnterNum')"
                      maxlength="10"
                    ></el-input>
                  </el-col>
                  <el-col :span="3" class="unit" v-if="form.ingredientIds[j].ingredientId">
                    <template v-for="item in ingredientList">
                      <span :key="item.id" v-if="item.id == form.ingredientIds[j].ingredientId">{{ item.unit }}</span>
                    </template>
                  </el-col>
                  <el-col
                    :span="5"
                    class="handle-btn"
                    v-if="action != 'detail'"
                  >
                    <i
                      class="el-icon-remove-outline"
                      v-if="form.ingredientIds.length > 1"
                      @click="removeIngredientIds(j)"
                    ></i>
                    <i
                      class="el-icon-circle-plus-outline"
                      v-if="j == form.ingredientIds.length - 1"
                      @click="addIngredientIds(j)"
                    ></i>
                  </el-col>
                </el-row>
              </template>
            </div>
          </el-form-item>
        </div>

        <div class="form-module">
          <div class="form-module-tit">{{ $locale("global.dispRelatedSettings") }}</div>
          <div class="clearfix">
            <el-form-item :label="$locale('global.hiddenSetting')" class="undisplay">
              <div class="undisplay-btn clearfix">
                <el-button
                  v-for="btn in unDisplayBtn"
                  :key="btn.text"
                  :class="
                    form[btn.keyName] == true
                      ? 'egl-btn-white-gray-border'
                      : 'egl-btn-white'
                  "
                  @click="unDisplay_fn(btn.keyName)"
                  >{{ btn.text }}</el-button
                >
              </div>
            </el-form-item>
          </div>
          <div class="clearfix">
            <el-form-item :label="$locale('global.btnBackgroundColor') + '（' + $locale('global.POS') + '）'" prop="bgColor">
              <ColorPicker v-model="form.bgColor" @change="clearFormValidate('bgColor')" />
            </el-form-item>
            <el-form-item :label="$locale('global.btnTextColor') + '（' + $locale('global.POS') + '）'" prop="fontColor">
              <ColorPicker v-model="form.fontColor" @change="clearFormValidate('fontColor')" />
            </el-form-item>
            <!-- <el-form-item :label="$locale('form.displayPOS')" prop="groupId">
              <el-select
                      :placeholder="$locale('shop.plsSelectDepartment')"
                      v-model="form.groupId"
              >
                <el-option
                        v-for="item in departmentOption"
                        :label="item.name"
                        :value="item.id"
                        :key="item.id"
                ></el-option>
              </el-select>
            </el-form-item>
            <el-form-item :label="$locale('global.displayOrder') + '（' + $locale('global.POS') + '）'" prop="sort">
              <el-input
                v-model.number="form.sort"
                :placeholder="$locale('form.plsEnterNumDispOrder_POS')"
                maxlength="5"
              ></el-input>
            </el-form-item> -->
            <!-- <el-row :gutter="10">
            </el-form-item>
            <el-row :gutter="10">
              <el-col :span="12">
                <el-form-item :label="$locale('global.btnBackgroundColor') + '（' + $locale('global.POS') + '）'" prop="bgColor" class="makeFull">
                  <ColorPicker v-model="form.bgColor" @change="clearFormValidate('bgColor')" />
                </el-form-item>
              </el-col>
              <el-col :span="12">
                <el-form-item :label="$locale('global.btnTextColor') + '（' + $locale('global.POS') + '）'" prop="fontColor" class="makeFull">
                  <div class="color-picker-box font-color">
                    <el-input v-model="form.fontColor" readonly></el-input>
                    <div class="egl-color-picker">
                      <i class="iconfont iconcolor-lens color-disc-icon"></i>
                      <el-color-picker v-model="form.fontColor"></el-color-picker>
                    </div>
                  </div>
                  </el-form-item>
                </el-col>
            </el-row> -->
            <el-row :gutter="10">
                <el-col :span="12">
                  <el-form-item :label="$locale('form.displayPOS')" prop="groupId" class="makeFull">
                    <el-select
                            :placeholder="$locale('shop.plsSelectDepartment')"
                            v-model="form.groupId"
                    >
                      <el-option
                              v-for="item in departmentOption"
                              :label="item.name"
                              :value="item.id"
                              :key="item.id"
                      ></el-option>
                    </el-select>
                  </el-form-item>
                </el-col>
                <!-- 10236 reduction -->
                <el-col :span="12">
                  <el-form-item :label="$locale('global.displayOrder') + '（' + $locale('global.POS') + '）'" prop="sort" class="makeFull">
                    <el-input
                      v-model.number="form.sort"
                      :placeholder="$locale('form.plsEnterNumDispOrder_POS')"
                      maxlength="5"
                    ></el-input>
                  </el-form-item>
                </el-col>
            </el-row>
            <el-row :gutter="20">
            <el-col :span="12">
              <el-form-item :label="$locale('form.displaySC')" prop="scGroupId" class="makeFull">
                <el-select
                  :placeholder="$locale('shop.plsSelectDepartment')"
                  v-model="form.scGroupId"
                >
                  <el-option
                    v-for="item in scDepartmentOption"
                    :label="item.name"
                    :value="item.id"
                    :key="item.id"
                  ></el-option>
                </el-select>
              </el-form-item>
            </el-col>
            <!-- 10236 reduction -->
            <el-col :span="12">
              <el-form-item :label="$locale('global.displayOrder') + '（' + $locale('global.selfCashier') + '）'" prop="scSort" class="makeFull">
                <el-input
                  v-model.number="form.scSort"
                  :placeholder="$locale('form.plsEnterNumDispOrder_SC')"
                  maxlength="5"
                ></el-input>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row :gutter="10">
            <el-col :span="12">
              <el-form-item :label="$locale('shop.description')" prop="description" style="width: 100%;">
                <el-input
                  v-model="form.description"
                  type="textarea"
                ></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item :label="$locale('shop.recommend')" style="width: 100%;">
                <el-checkbox-group
                  v-model="checkboxGroup.sc"
                >
                  <el-checkbox label="recommend">{{ $locale("shop.recommend.sc") }}</el-checkbox>
                </el-checkbox-group>
              </el-form-item>
            </el-col>
          </el-row>
            <el-row :gutter="10">
                <el-col :span="8">
                  <el-form-item :label="$locale('global.status')" prop="publish" class="makeFull">
                    <el-select v-model="form.publish">
                      <el-option
                        v-for="item in publishOption"
                        :label="item.text"
                        :value="item.type"
                        :key="item.type"
                      ></el-option>
                    </el-select>
                  </el-form-item>
                </el-col>
                <el-col :span="8">
                  <el-form-item :label="$locale('shop.kiosk.groups')" class="makeFull">
                    <el-select v-model="form.cinemaDailySelective" >
                      <el-option v-for="item in cinemaDailys"
                        :label="item.name"
                        :value="item.id"
                        :key="item.id"/>
                    </el-select>
                  </el-form-item>
                </el-col>
                <el-col :span="8">
                  <el-form-item :label="$locale('bookKeeping.journal.dept')+' ('+$locale('setting.pay.accgroup')+')'" class="makeFull">
                    <el-select v-model="form.journalType">
                      <el-option v-for="item in tradeGroupList"
                        :label="item.name"
                        :key="item.id"
                        :value="item.id"
                      />
                    </el-select>
                  </el-form-item>
                </el-col>
            </el-row>
            <el-row :gutter="20">
              <el-col :span="24">
                <el-form-item :label="$locale('rules.alertMessage')" style="width: 100%;">
                  <el-row
                    :gutter="20"
                    class="message"
                    v-for="(item, idx) in form.customizeMsg"
                    :key="idx"
                  >
                    <el-col :span="8">
                      <el-select v-model="item.deviceType">
                        <el-option
                          v-for="platfom in platforms"
                          :key="platfom.value"
                          :label="platfom.label"
                          :value="platfom.value"
                          :disabled="isPlatformDisabled(platfom.value, idx)"
                        ></el-option>
                      </el-select>
                    </el-col>
                    <el-col :span="8">
                      <el-input v-model="item.message" :placeholder="$locale('form.plsEnterMsg')" />
                    </el-col>
                    <el-col :span="8">
                      <el-button class="decrease" @click="decreaseMessage(idx)" v-if="form.customizeMsg.length > 1">
                        <i class="el-icon-minus"></i>
                      </el-button>
                      <el-button class="increase" @click="increaseMessage" v-if="showBtn('increase', idx)" >
                        <i class="el-icon-plus"></i>
                      </el-button>
                    </el-col>
                  </el-row>
                </el-form-item>
              </el-col>
            </el-row>
            <!-- 10236 reduction -->
          </div>
          <ApproveField v-model="form.approveDate" :formData="form" fieldName="approveDate" />
        </div>

      </el-form>
      <div slot="footer" class="dialog-footer" v-if="this.action != 'detail'">
        <el-row :gutter="20">
          <el-col :span="24">
            <el-button class="egl-btn-white" @click="colse_fn">{{$locale("global.cancel")}}</el-button>
            <el-button class="egl-btn-yellow" @click="save_fn">{{$locale("global.confirm")}}</el-button>
          </el-col>
        </el-row>
      </div>
    </el-dialog>
</template>

<script>
import TaxSelect from "@/components/common/TaxSelect";
// import ShopProductPrice from "@/components/common/ShopProductPrice";
import ApproveField from "@/components/common/ApproveField";
import { positiveNumValidator, hexColorValidator } from "@/utils/formFieldValidator";
import {
  kioskOpts, kioskMaps, taxRatesMap, taxRateOpts, saleFormMap, saleForm,
} from "@/utils/common.js"
import { taxOff, taxOffDec, taxAddDec } from "@/utils/math.js"
import { getListService } from "@/helpers/service/api/tradeGroup"
import ColorPicker from "@/components/common/ColorPicker";
import UploadContainer from "@/components/common/UploadContainer";
import BoolSelect from "@/components/common/BoolSelect";
import RemoteSelectV2 from "@/components/common/RemoteSelect-v2";
import { getClientListService } from "@/helpers/service/api/common";
import { getCouponTypeListForSelect } from "@/helpers/service/api/coupon";
import { getCinemaDailyListService } from "@/helpers/service/api/theaterDailyShow.js";

import { decimal2 } from "@/utils/utils";

export default {
  name: "ConcessionDialog",
  data() {
    return {
      checkboxGroup: {
        sc: false,
      },
      roundSetting: window.localStorage.getItem("round"),
      form: this.createForm(),
      visible: false,
      actionText: "",
      tradeGroupList: [],

      productTypeOption: saleForm,
      saleFormMap : saleFormMap,

      unDisplayBtn: [
        {
          text: this.$locale("global.POS"),
          keyName: "displayPos"
        },
        {
          text: this.$locale("global.selfCashier"),
          keyName: "displaySelfCashier"
        }
      ],
      publishOption: [],
      uploadUrl: "/api/system/uploadFile",
      file: [],
      tokenObj: {},
      rule: {
        name: {
          required: this.$locale("form.plsEnterYourName")
        },
        price: {
          required: this.$locale("form.plsEnterPrice")
        },
        salesGroup: {
          required: this.$locale("form.plsEnterSalesDepartment"),
        },
        productType: {
          required: this.$locale("shop.plsSelectProductType"),
        },
      },
      taxIndication : taxRateOpts,
      taxRatesMap : taxRatesMap,
      kioskOpts : kioskOpts,
      kioskMaps : kioskMaps,
      cinemaDailys: [],
      isDisStockPlace: false,
      formRules: {
        name: [ {
          required: true,
          message: this.$locale("form.plsEnterYourName"),
          trigger: "blur",
        } ],
        price: [
          {
            required: true,
            message: this.$locale("form.plsEnterPrice"),
            trigger: "blur",
          },
          // {
          //   type: "number",
          //   message: this.$locale("form.mustFillInNum"),
          //   trigger: "blur",
          // },
          // {
          //   validator: positiveNumValidator,
          //   trigger: "blur",
          // },
        ],
        productType: [ {
          required: true,
          message: this.$locale("shop.plsSelectProductType"),
          tirgger: "change",
        } ],
        productCost: [
          {
            validator: positiveNumValidator,
            trigger: "blur",
          }
        ],
        priceWithoutTax: [
          {
            validator: positiveNumValidator,
            trigger: "blur",
          }
        ],
        sort: [
          {
            validator: positiveNumValidator,
            trigger: "blur",
          }
        ],
        bgColor: [
          {
            validator: hexColorValidator,
            trigger: "blur",
          }
        ],
        fontColor: [
          {
            validator: hexColorValidator,
            trigger: "blur",
          }
        ],
        useStock: [ {
          required: true,
          message: this.$locale("shop.plsSelectUseStock"),
        } ],
      },
      boolSelectObj: [
        {
          label: this.$locale("shop.option.utilize"),
          value: true
        },
        {
          label: this.$locale("shop.option.notUsed"),
          value: false
        }
      ],
      comClientList: [],
      comCouponList: [],
      decimal2,
      platforms: [
        {
          label: this.$locale("global.POS"),
          value: "POS",
        },
        {
          label: this.$locale("global.selfCashier"),
          value: "SELFCASHIER",
        },
      ],
    };
  },
  methods: {
    createForm() {
      return {
        barCode: "",
        productCode: '',
        name: "",
        price: "",
        taxRate: 0.1,
        notTaxPrice: 0,
        productCost: 0,
        priceWithoutTax: 0,
        taxRateCost: "percentTen",
        imageUrl: "",

        stockPlace: "",

        inventory: 0,
        groupId: '',
        unit: "",
        salesGroup: { id: null, name: null },
        productType: "SALES_ITEM",
        clientId: "",
        options: [],
        unavailableCoupons: [],
        tradeGroupList: [],
        cinemaDailySelective:'',
        displayPos: true,
        displaySelfCashier: true,
        bgColor: "#FFFFFF",
        fontColor: "#000000",
        sort: "",
        scGroupId: "",
        scSort: "",
        publish: "RELEASE",
        ingredientIds: [
          {
            ingredientId: "",
            ingredientName: "",
            ingredientQty: 0
          }
        ],
        approveDate: this.$moment().startOf("day").valueOf(),
        useStock: true,
        useAutoSoldOut: false,
        description: "",
        salesDepartment: "",
        optionTitle: "種類",
        customizeMsg: [
          {
            deviceType: "",
            message: "",
          }
        ],
      };
    },
    colse_fn() {
      this.$emit("closeFn");
    },
    save_fn() {
      const that = this;
      // let obj = RuleTest(this.rule, this.form);
      // let options = JSON.parse(JSON.stringify(this.form.options));
      let options = [];
      let ingredientIds = [];
      let data = { ...this.form };

      this.$refs.detailForm.validate(valid => {
        if (valid) {
          // if (!obj.success) {
          //   this.$alert(obj.message, {
          //     showClose: false
          //   });

          //   return;
          // }

          // data = { ...obj.data };

          // for (let i = 0; i < that.salesGroupData.length; i++) {
          //   if (that.salesGroupData[i].id == data.salesGroup) {
          //     data.salesGroup = {
          //       id: that.salesGroupData[i].id,
          //       name: that.salesGroupData[i].name,
          //     };

          //     break;
          //   }
          // }

          const targetGroup = that.salesGroupData.find(group => group.id === data.salesGroup.id) || {};
          data.salesGroup = {
            id: targetGroup.id,
            name: targetGroup.name,
          };

          this.form.options.map(optionObj => {
            if (optionObj.name != "") {
              let item = { ...optionObj, ingredientIds: [] };
              if (optionObj.ingredientIds.length > 0) {
                optionObj.ingredientIds.map(ingredientObj => {
                  if (ingredientObj.ingredientId != "") {
                    item.ingredientIds.push({
                      ...ingredientObj,
                      ingredientQty: parseFloat(ingredientObj.ingredientQty)
                    });
                  }
                });
              }

              options.push(item);
            }
          });

          if (options.length == 0) {
            this.form.ingredientIds.map(thisObj => {
              if (thisObj.ingredientId != "") {
                ingredientIds.push({ ...thisObj });
              }
            });
          }

          data.options = options;
          data.ingredientIds = ingredientIds;
          data.recommend = this.checkboxGroup.sc;
          this.$emit("returnMsg", data);
        } else {
          setTimeout(() => {
            const isError = document.getElementsByClassName("is-error");
            isError[0].querySelector("input").focus();
          }, 100);

          return false;
        }
      });
    },
    getNotTaxPrice() {
      let { price, productCost, taxRate, taxRateCost } = this.form;
      let notTaxPrice = taxOff(price, taxRate, this.roundSetting)
      let ctaxrate = 0
      if(taxRateCost == "percentTen") ctaxrate = 0.1
      else if (taxRateCost == "percenteight") ctaxrate = 0.08
      else ctaxrate = 0

      let noTaxCost = taxOffDec(productCost, ctaxrate, this.roundSetting)
      this.form = { ...this.form,
        notTaxPrice: isNaN(notTaxPrice) ? 0 : notTaxPrice,
        priceWithoutTax : isNaN(noTaxCost) ? 0 : noTaxCost,
      };
    },
    getTaxedPrice() {
      let {  taxRateCost, priceWithoutTax } = this.form;
      let ctaxrate = 0
      if(taxRateCost == "percentTen") ctaxrate = 0.1
      else if (taxRateCost == "percenteight") ctaxrate = 0.08
      else ctaxrate = 0

      let taxedCost = taxAddDec(priceWithoutTax, ctaxrate, this.roundSetting)
      this.form = { ...this.form,
        productCost: isNaN(taxedCost) ? '' : taxedCost,
      };
    },
    uploadSuccess(res) {
      if (res.success) {
        this.form = { ...this.form, imageUrl: res.data };
      }
      this.file = [];
    },
    deleteImg() {
      this.form = { ...this.form, imageUrl: "" };
    },
    addTableRow() {
      let formObj = { ...this.form };

      if (formObj.options[formObj.options.length - 1].name != "") {
        formObj.options.push(this.createOptionObj());

        this.form = { ...formObj };
      }
    },
    removeTableRow(index) {
      let formObj = { ...this.form };
      formObj.options.splice(index, 1);

      this.form = { ...formObj };
    },
    unDisplay_fn(keyName) {
      let formObj = { ...this.form };
      formObj[keyName] = !formObj[keyName];

      this.form = { ...formObj };
    },
    createOptionObj: () => {
      return {
        barCode: "",
        productCode: "",
        inventory: 0,
        stockPlace: "",
        name: "",
        ingredientIds: [
          {
            ingredientId: "",
            ingredientName: "",
            ingredientQty: 0
          }
        ],
      };
    },
    chooseIngredient(i, j, val) {
      let form = JSON.parse(JSON.stringify(this.form));
      let text = "";

      for (let i = 0; i < this.ingredientList.length; i++) {
        if (this.ingredientList[i].id == val) {
          text = this.ingredientList[i].name;
          break;
        }
      }

      form.options[i].ingredientIds[j].ingredientName = text;

      this.form = form;
    },
    chooseIngredientIds(i, val) {
      let form = JSON.parse(JSON.stringify(this.form));
      let text = "";

      for (let i = 0; i < this.ingredientList.length; i++) {
        if (this.ingredientList[i].id == val) {
          text = this.ingredientList[i].name;
          break;
        }
      }

      form.ingredientIds[i].ingredientName = text;

      this.form = form;
    },
    addIngredient(i) {
      let form = JSON.parse(JSON.stringify(this.form));
      let ingredientLength = form.options[i].ingredientIds.length;

      if (
        form.options[i].ingredientIds[ingredientLength - 1].ingredientId != ""
      ) {
        form.options[i].ingredientIds.push({
          ingredientId: "",
          ingredientName: "",
          ingredientQty: 0
        });
      }

      this.form = form;
    },
    addIngredientIds() {
      let form = JSON.parse(JSON.stringify(this.form));

      form.ingredientIds.push({
        ingredientId: "",
        ingredientName: "",
        ingredientQty: 0
      });

      this.form = form;
    },
    removeIngredient(i, j) {
      let form = JSON.parse(JSON.stringify(this.form));

      form.options[i].ingredientIds.splice(j, 1);

      this.form = form;
    },
    removeIngredientIds(i) {
      let form = JSON.parse(JSON.stringify(this.form));

      form.ingredientIds.splice(i, 1);

      this.form = form;
    },
    clearFormValidate(fieldName) {
      if (fieldName) {
        this.$refs.detailForm.clearValidate(fieldName);
      } else {
        this.$refs.detailForm.clearValidate();
      }
    },
    priceFormatter(value, type) {
      this.form[type] = Number(decimal2(value))
    },
    priceFormatterForIngredient(value, i, j, isHaveName) {
      if (isHaveName) {
        this.form.options[i].ingredientIds[j].ingredientQty = decimal2(value)
      } else {
        this.form.ingredientIds[j].ingredientQty = decimal2(value)
      }
    },
    increaseMessage() {
      if (this.form.customizeMsg.length >= this.platforms.length) { return; }
      this.form.customizeMsg.push({
        deviceType: "",
        message: "",
      });
    },
    decreaseMessage(idx) {
      this.form.customizeMsg.splice(idx, 1);
    },
    isPlatformDisabled(platformValue, currentIdx) {
      return this.form.customizeMsg.some((msg, idx) => idx !== currentIdx && msg.deviceType === platformValue);
    },
    showBtn(type, idx) {
      if (type === "increase") {
        if (this.form.customizeMsg.length >= this.platforms.length) {
          return false;
        }
        if (
          this.form.customizeMsg.length > 1 &&
          this.form.customizeMsg.length < 2 &&
          this.form.customizeMsg.length - 1 === idx
        ) {
          if (idx === 0) {
            return false;
          }
          return true;
        } else if (this.form.customizeMsg.length === 1) {
          return true;
        }
        return false;
      }
    },
  },
  mounted() {
    getCinemaDailyListService({ cinemaId: window.localStorage.getItem("cinemaId") }).then(res => {
      if (res.data && res.data.data.length > 0) {
        this.cinemaDailys = res.data.data;
      }
    });
    // let dictionary = window.localStorage.getItem("dictionary") || "";
    // let productTypeOption = [];
    const statusArr = [
      {
        type: "RELEASE",
        text: this.$locale("global.sale"),
      },
      {
        type: "RESERVE",
        text: this.$locale("global.stopSelling"),
      }
    ];

    // if (dictionary != "") {
    //   dictionary = JSON.parse(dictionary);

    //   Object.keys(dictionary.ticketing.ProductType).map(keyName => {
    //     if (keyName == "SALES_ITEM") {
    //       productTypeOption.push({
    //         label: this.$locale("global.purchase"),
    //         val: "SALES_ITEM"
    //       });
    //     } else if (keyName == "CONSIGNMENT") {
    //       productTypeOption.push({
    //         label: this.$locale("global.entrust"),
    //         val: "CONSIGNMENT"
    //       });
    //     } else {
    //       productTypeOption.push({
    //         label: keyName,
    //         val: keyName
    //       });
    //     }
    //   });
    // }

    this.productTypeOption = saleForm;
    this.publishOption = statusArr;
  },
  props: {
    action: {
      type: String,
      default: "create"
    },
    actionVisible: {
      type: Boolean,
      default: false
    },
    departmentOption: {
      type: Array,
      default: () => [],
    },
    scDepartmentOption: {
      type: Array,
      default: () => [],
    },
    salesGroupData: {
      type: Array,
      default: () => [],
    },
    couponTypeList: {
      type: Array,
      default: () => [],
    },
    detailObj: {
      type: Object,
      default: () => [],
    },
    ingredientList: {
      type: Array,
      default: () => [],
    },
    clientList: {
      type: Array,
      default: () => [],
    },
    brandSetting: {
      type: Object,
      default: () => {},
    },
  },
  computed: {
    options() {
      return this.form.options;
    },
    isOpen: {
      get() {
        return this.visible;
      },
      set() {
        this.colse_fn();
      },
    }
  },
  watch: {
    actionVisible(_vn) {
      if (_vn) {
        this.$nextTick(() => {
          if (this.tradeGroupList.length === 0) {
            getListService({
              brandId: window.localStorage.getItem('brandId')
            }).then(res => {
              this.tradeGroupList = res.data
            }).catch( err => {
              console.log(err)
            })
          }
          this.$refs["selectV2Client"].page = 1;
          this.$refs["selectV2Coupon"].page = 1;
          if (this.action !== "create") {
            if (this.form.clientId) {
              getClientListService({
                ids: [ this.form.clientId ],
                page: 0,
                pageSize: 9999,
                field: ["id", "name"]
              }).then(res => {
                this.comClientList = this.$_.uniqBy(res.data.data.concat(this.clientList), "id");
              });
            }
            if (this.form.unavailableCoupons && this.form.unavailableCoupons.length > 0) {
              getCouponTypeListForSelect({
                cinemaId: window.localStorage.getItem("cinemaId"),
                ids: this.form.unavailableCoupons,
                page: 0,
                pageSize: 9999,
                field: ["id", "name"]
              }).then(res => {
                this.comCouponList = this.$_.uniqBy(res.data.data.concat(this.couponTypeList), "id");
              });
            }
          }
          this.comClientList = this.clientList;
          this.comCouponList = this.couponTypeList;
        });
      }
      if (_vn === false) {
        this.visible = this.actionVisible;
        return;
      }

      let formObj = this.createForm();
      let actionText = "";

      if (this.detailObj.id) {
        formObj = {
          ...formObj,
          ...this.detailObj,
          salesGroup: this.detailObj.salesGroup ? this.detailObj.salesGroup : formObj.salesGroup,
        };
        this.checkboxGroup.sc = this.detailObj.recommend;
      }

      if (this.action == "create") {
        actionText = this.$locale("global.create");
      } else if (this.action == "detail") {
        actionText = this.$locale("global.detail");
      } else {
        actionText = this.$locale("global.edit");
      }

      this.actionText = actionText;
      if (this.$refs.detailForm) {
        this.$refs.detailForm.resetFields();
      }
      this.visible = this.actionVisible;
      this.tokenObj = {
        Authorization: window.localStorage.getItem("token")
      };

      if (formObj.options && formObj.options.length === 0) {
        formObj.options.push(this.createOptionObj());
        if (formObj.ingredientIds.length === 0) {
          formObj.ingredientIds.push({
            ingredientId: "",
            ingredientName: "",
            ingredientQty: 0,
          });
        }
      } else {
        formObj.options.forEach(option => {
          if (option.ingredientIds.length === 0) {
            option.ingredientIds.push({
              ingredientId: "",
              ingredientName: "",
              ingredientQty: 0,
            });
          }
        });
      }

      this.form = { ...formObj };

      this.getNotTaxPrice();
    },
    "form.useStock"(newV) {
      // 不使用库存管理的商品不适用自动售罄
      if (!newV) {
        this.form.useAutoSoldOut = false;
      }
    },
    options: {
      handler(newV) {
        let isDis = newV.some(item => item.stockPlace);
        if (isDis) {
          this.form.stockPlace = "";
        }
        this.isDisStockPlace = isDis;

        if (newV.length === 0 || (newV.length === 1 && newV[0].name === "") && this.form.ingredientIds.length === 0) {
          this.form.ingredientIds.push({
            ingredientId: "",
            ingredientName: "",
            ingredientQty: 0
          });
        } else if (newV.length === 1) {
          const _vialdValues = [];
          Object.keys(newV[0]).forEach(_key => {
            if (newV[0][_key] && typeof newV[0][_key] === "string") {
              _vialdValues.push(_key);
            }
          });

          if (_vialdValues.length === 1 && _vialdValues[0] === "uuid") {
            const _baseOptionsObj = this.createOptionObj();
            this.form.options = [ _baseOptionsObj ];
          }
        }
      },
      deep: true,
    },
  },
  components: {
    ApproveField,
    TaxSelect,
    // ShopProductPrice,
    ColorPicker,
    UploadContainer,
    BoolSelect,
    RemoteSelectV2
  }
};
</script>

<style scoped lang="less">
  .makeFull {
    width: 100% !important;
  }

  .inventory-list {
    .inventory-name {
        line-height: 1;
    }

    &:not(:first-of-type) {
      .inventory-name {
        padding-top: 20px;
      }
    }
  }

  .message {
    margin-bottom: 22px;
  }
  .increase, .decrease {
    width: 40px;
    height: 40px;
    padding: 0;
    &:hover,
    &:focus {
      border: 1px solid @primary-yellow;
      background-color: @pure-white;
      i {
        color: @primary-yellow;
      }
    }
  }
</style>
